module.exports = __webpack_public_path__ + "img/project-details-4.d085bb67.jpg";